module.exports = __webpack_public_path__ + "static/media/29ADMSPC38.e2ec386a.jpg";